import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'aum-switch-toggle',
    templateUrl: './switch-toggle.component.html',
    styleUrls: ['./switch-toggle.component.scss'],
})
export class SwitchToggleComponent {
    @Output() toggle = new EventEmitter<boolean>();
    @Input() checked: boolean;
    @Input() disabled: boolean;

    constructor() {}

    onToggleChange($event: MatSlideToggleChange) {
        this.toggle.emit($event.checked);
    }
}
